// import { swup } from 'src/App';
function main() {
    var controller;
    var elements = document.querySelectorAll('.like-dislike');
    elements.forEach(function (element) {
        var buttons = element.querySelectorAll('.like-dislike__button');
        buttons.forEach(function (button) {
            var value = button.dataset.value;
            button.addEventListener('click', function () {
                if (controller) {
                    controller.abort();
                }
                controller = new AbortController();
                var signal = controller.signal;
                var isChecked = this.getAttribute('aria-checked') === 'true';
                // Uncheck all button;
                buttons.forEach(function (button) { return button.setAttribute('aria-checked', 'false'); });
                if (!isChecked) {
                    this.setAttribute('aria-checked', 'true');
                }
                var body = new FormData();
                body.append('action', 'like_dislike_post');
                body.append('value', !isChecked ? value : null);
                body.append('nonce', window.likeDislikePost.nonce);
                fetch(window.site.ajaxurl, { method: 'POST', body: body, signal: signal })
                    .then(function (res) { return res.json(); })
                    .catch(function () { });
            });
        });
    });
}
main();
export {};
